import twinFields from './twinFields';
import { mapState } from 'vuex';
export default {
  name: 'TemplateTextField',
  props: {
    value: {
      type: String,
      required: true
    },
    customParameters: {
      type: Object,
      required: true
    },
    twin: {
      type: [Object, Array],
      required: false,
      default: () => null
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    disableTwinFields: {
      type: Boolean,
      required: false,
      default: false
    },
    dataCy: {
      type: String,
      required: false,
      default: () => undefined
    }
  },
  data: () => ({
    searchForTemplateParameter: '',
    showMenu: false
  }),
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    twinFields() {
      const fields = twinFields.getDefinitions(this.$t, this.twin, {
        customParameters: this.customParameters
      });
      if (this.disableTwinFields !== false) {
        return Object.fromEntries(Object.entries(fields).filter(([key]) => !key.startsWith('twin.')));
      }
      return fields;
    },
    filteredTwinFields() {
      const items = Object.entries(this.twinFields).map(([key, value]) => ({
        placeholder: key,
        ...value
      }));
      return items.filter(field => field.defaultLabel.toLowerCase().trim().includes(this.searchForTemplateParameter.toLowerCase().trim()));
    },
    template: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    appendParameterToTemplate(parameter) {
      this.template = `${this.template}{${parameter.placeholder}}`;
      this.$refs.templateInput.focus();
    }
  }
};